import React, { Component } from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { deletePositionApi, getPositionApi } from "./Api";
import { connect } from "react-redux";
import { ComponentHeader, InformationModal } from "../common";
import PositionForm from "./PositionForm";
import { API_LIMIT, START_PAGE } from "../../utils/Constant";
import { withRouter } from "../../utils/hoc/withRouter";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";

export class PositionTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dummyData: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      totalPages: null,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,
    };
  }

  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getPositionApi(this);
  }

  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData,
    });
  };

  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };

  deleteHandle = (id) => {
    deletePositionApi(id, this, this.openCloseDeleteModal);
  };

  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;

    if (prevPage !== page) {
      this.setState({ currentPage: page }, () => {
        this.props.getPositionApi(this);
      });
    }
  }

  render() {
    const { showEdit } = this.state;
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;
    return (
      <section className="request-section">
        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.position} position?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        {showEdit && (
          <PositionForm
            show={showEdit}
            onHide={this.showEditModal}
            editData={this.state.editData}
            this={this}
          />
        )}
        <ComponentHeader
          title="Position"
          isSearch={false}
          placeholder={"Search position"}
          onChangeMethod={this.onChangeMethod}
          clearSearch={() => this.clearSearch()}
          primaryBtn=""
          handlePrimaryBtn={() => {
            this.setState({ showEdit: true });
          }}
        />
        <div className="commom-table-wrapper">
          <CustomTable
            ctx={this}
            data={listData?.list || []}
            columns={[
              {
                width: 250,
                title: "Position",
                dataIndex: "position",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return rowData.position;
                },
              },
              {
                width: 200,
                title: "Code",
                dataIndex: "code",
                className: "name",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return rowData.code;
                },
              },
              {
                width: 20,
                title: "Action",
                dataIndex: "",
                className: "",
                fixed: "right",
                isCell: true,
                render: (text, rowData, dataKey) => {
                  return (
                    <OptionsDropdown
                      editHandler={() => {
                        this.showEditModal(rowData);
                      }}
                      deleteHandler={null}
                    />
                  );
                },
              },
            ]}
            loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  masterCategoryState: state.MasterCategoryState,
});

const mapDispatchToProps = {
  getPositionApi,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PositionTab));
